var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#767474"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_13893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9977 16.9986C9.24269 16.9986 7.48689 17.0002 5.73191 16.9977C4.64542 16.9961 4.00264 16.3574 4.00181 15.2759C4.00016 11.7519 3.99933 8.22783 4.00181 4.70295C4.00264 3.64714 4.64956 3.00354 5.71035 3.00188C8.65383 2.99939 11.5981 2.9969 14.5416 3.01183C14.734 3.01266 14.9712 3.11302 15.1098 3.24738C16.0138 4.12155 16.902 5.01231 17.7795 5.91302C17.8981 6.03411 17.9885 6.24145 17.9894 6.40982C18.0018 9.39477 18.0026 12.3806 17.996 15.3655C17.9935 16.3433 17.33 16.9944 16.3464 16.9977C14.5632 17.0027 12.78 16.9986 10.9977 16.9986ZM5.58594 4.58435C5.58594 5.63103 5.58594 6.63375 5.58594 7.64643C8.18025 7.64643 10.7538 7.64643 13.3257 7.64643C13.3257 6.60804 13.3257 5.60532 13.3257 4.58435C10.7389 4.58435 8.17693 4.58435 5.58594 4.58435ZM11.025 15.4335C12.299 15.4294 13.3432 14.3868 13.3481 13.1154C13.3531 11.8356 12.2857 10.7749 10.9952 10.7774C9.70549 10.7798 8.63807 11.8481 8.65134 13.1245C8.66461 14.415 9.71627 15.4385 11.025 15.4335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_13893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSave);
export default __webpack_public_path__ + "static/media/ic_save.88344f1c91b591aedc2ec6f93ef584f5.svg";
export { ForwardRef as ReactComponent };